import { isFlagActive } from "@/helpers/shared/flags";
import { useAuthStore } from "@/stores/authStore";
import { computed } from "vue";

export function usePlannerPermissions() {
  const authStore = useAuthStore();

  const view = computed(() => {
    return (
      authStore.currentInstitution?.settings.planner.enabledEmployees || false
    );
  });

  const viewOld = computed(() => {
    return isFlagActive("oldPlanner");
  });

  return { view, viewOld };
}
